angular.module('angus.controllers').controller('marginAnalysisSettingsCtrl', [
  '$scope', '$rootScope', '$http', 'periodIndicators', 'productsService', 'hierarchyService', 'tradeClassService', 'constantsService','priceCodeService',
  function ($scope, $rootScope, $http, periodIndicators, productsService, hierarchyService, tradeClassService, constantsService, priceCodeService) {

    $scope.periodIndicators = constantsService.invoicePeriodIndicators.enums;
    $scope.zeroPriceSalesOptions = constantsService.includeExcludeOnly.enums;
    $scope.subscriberId = $rootScope.user.subscriberId;
    $scope.subscriberAbosKey = $rootScope.user.subscriberAbosKey;

    priceCodeService.getBasePriceCodes($scope.subscriberAbosKey)
        .then(function(priceCodes){
            $scope.priceCodes = priceCodes;
        });

    productsService.getProducts()
      .then(function (products) {
        $scope.products = products;
      });

    tradeClassService.getTradeClasses()
      .then(function (classes) {
        $scope.tradeClasses = classes;
      });

    $scope.openDivisionHierarchyView = function() {
      hierarchyService.openDivisionModal($scope.widget.instance.settings.hierarchyNodeId)
        .then(function(nodeId) {
          $scope.widget.instance.settings.hierarchyNodeId = nodeId;
        });
    };
  }
]);
